var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPennant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 5.75C17.75 5.59375 18.2812 6.53125 17.7812 7.15625C15.2812 10.2812 12.0312 11.0312 11.875 11.0625C10 11.4688 8.5625 11.5938 7.65625 11.6562C7.375 11.6562 5 11.7188 2.5 13.4062V15.75C2.5 15.9062 2.375 16 2.25 16H1.25C1.09375 16 1 15.9062 1 15.75V3.34375C0.40625 3.0625 0 2.46875 0 1.75C0 0.8125 0.78125 0 1.75 0C2.8125 0 3.78125 1.0625 3.40625 2.28125C4.9375 2.21875 6.90625 2.53125 9.21875 3.78125C13.6562 6.1875 16.25 5.90625 16.9375 5.75ZM11.5625 9.59375C11.5938 9.59375 13.6562 9.09375 15.5625 7.34375C14.0625 7.28125 11.6875 6.8125 8.53125 5.09375C5.90625 3.6875 3.875 3.625 2.5 3.875V11.6562C3.65625 10.9688 5.40625 10.25 7.59375 10.1562C8.40625 10.0938 9.78125 9.96875 11.5625 9.59375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennant);
export default __webpack_public_path__ + "static/media/pennant.7ca51f28cb2d071052d8eb9778ab731f.svg";
export { ForwardRef as ReactComponent };